import { Skeleton } from "@tql/ui-components-react/kendo/indicators";
import type { ReactNode } from "react";

export const DEFAULT_SKELETON_WIDTH = 75;

type HeaderFieldProps = {
	title: string;
	isLoading: boolean;
	children: ReactNode;
	skeletonWidth?: number | string;
};

export const HeaderField = ({
	title,
	isLoading,
	children,
	skeletonWidth = DEFAULT_SKELETON_WIDTH,
}: HeaderFieldProps) => (
	<div className={"completed-header-item"}>
		<div className={"completed-header-title"}>{title}</div>
		{isLoading ? (
			// eslint-disable-next-line @typescript-eslint/no-deprecated -- Skeleton still in use
			<Skeleton
				className={"completed-header-skeleton"}
				style={{ width: skeletonWidth }}
			/>
		) : (
			children
		)}
	</div>
);
